import React from 'react';

const wrapStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  marginTop: 2,
  fontSize: 'calc(11px + var(--font-size-bump))',
  fontWeight: 500,
  lineHeight: 1.3,
  color: 'var(--ink-3)',
};

const lineStyle: React.CSSProperties = { minWidth: 0 };

const mathStyle: React.CSSProperties = {
  ...lineStyle,
  fontVariantNumeric: 'tabular-nums',
  letterSpacing: '-0.01em',
  color: 'var(--ink-2)',
};

/** Stacked scorecard footnote — math / coverage as short lines, not one wall. */
export function ScorecardNote({
  note,
  noteLines,
}: {
  note?: string | null;
  noteLines?: string[] | null;
}) {
  const lines =
    noteLines && noteLines.length > 0
      ? noteLines.filter(Boolean)
      : note
        ? note
            .split('\n')
            .map(s => s.trim())
            .filter(Boolean)
        : [];
  if (!lines.length) return null;
  return (
    <div className="sc-stat-note" style={wrapStyle}>
      {lines.map((line, i) => (
        <div
          key={`${i}-${line}`}
          className={
            line.includes('÷') ? 'sc-stat-note-line is-math' : 'sc-stat-note-line'
          }
          style={line.includes('÷') ? mathStyle : lineStyle}
        >
          {line}
        </div>
      ))}
    </div>
  );
}
